// extracted by mini-css-extract-plugin
module.exports = {"closeButtonHover":"CloseButton_closeButtonHover__2fi8_","CloseButton":"CloseButton_CloseButton__2utQD"};